// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ResetPassword-module-container-D1h\\+a{display:flex;padding-block:var(--des-spacing-container-layout-between-section-2xs-xs-sm)}@media(min-width: 768px){.ResetPassword-module-container-D1h\\+a{padding-block:var(--des-spacing-container-layout-between-section-sl-md-mw)}}@media(min-width: 1280px){.ResetPassword-module-container-D1h\\+a{padding-block:var(--des-spacing-container-layout-between-section-lg-xl-2xl);justify-content:center}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "ResetPassword-module-container-D1h+a"
};
export default ___CSS_LOADER_EXPORT___;
